/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Dataprivacyconsent2Inputs */

const en__field_dataprivacyconsent2 = /** @type {(inputs: _Field_Dataprivacyconsent2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I declare my consent to the Data Privacy Consent`)
};

const de__field_dataprivacyconsent2 = /** @type {(inputs: _Field_Dataprivacyconsent2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ich erkläre mich einverstanden mit der Datenschutzerklärung`)
};

/**
* | output |
* | --- |
* | "I declare my consent to the Data Privacy Consent" |
*
* @param {_Field_Dataprivacyconsent2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_dataprivacyconsent2 = /** @type {((inputs?: _Field_Dataprivacyconsent2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Dataprivacyconsent2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_dataprivacyconsent2(inputs)
	return de__field_dataprivacyconsent2(inputs)
});
export { _field_dataprivacyconsent2 as "_field_dataPrivacyConsent" }